import Helpers from "./helpers";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import Masonry from "masonry-layout";
import ImagesLoaded from "imagesloaded";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// import GoogleMap from "./map";

// Init alpine plugins
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.start();

if (document.querySelector('[data-masonry]')) {
  const masonry = new Masonry('[data-masonry]', {
    columnWidth: '.item-width',
    itemSelector: '.item',
    percentPosition: true,
    gutter: 0,

    // Don't fire the layout on init
    initLayout: false,
  });

  // Fire the layout after images are loaded
  ImagesLoaded('[data-masonry]', function() {
    masonry.layout();
  });
}

const theme = () => {
  document.querySelectorAll("[data-swiper]").forEach((el) => {
    let args = {
      loop: true,
      onAny(event, args) {
        el.dispatchEvent(
          new CustomEvent(event, {
            detail: { ...args },
            bubbles: true,
          })
        );
      },
    };

    if (el.dataset.swiper) {
      Helpers.extend(args, JSON.parse(el.dataset.swiper));
    }

    new Swiper(el, args);
  });

  document.querySelectorAll("[data-gsap]").forEach((el) => {
    let args = {
      motionPath: {
        alignOrigin: [0.5, 0.5],
      },
      scrollTrigger: {
        trigger: "#" + el.id,
        start: "top 87", // begin movement when trigger is 87px away from top (change this to pull height of header)
        once: true, // do not scroll back up motion path
        scrub: 1,
      },
      ease: "power1.inOut",
    };

    if (el.dataset.gsap) {
      Helpers.extend(args, JSON.parse(el.dataset.gsap));
    }

    let tween = gsap.to('#'+el.id, args);
    // to make it responsive on window resize...
    window.addEventListener("resize", function() {
      tween.seek(0).invalidate().totalTime(tween.totalTime());
    });
  });

  window.dispatchEvent(new Event('themeReady'));
};

if (typeof wp !== "undefined") {
  window.onload = () => theme(); // backend
} else {
  theme(); // frontend
}
